/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Field_First_Name_PlaceholderInputs */

const en_auth_field_first_name_placeholder = /** @type {(inputs: Auth_Field_First_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jane`)
};

const pl_auth_field_first_name_placeholder = /** @type {(inputs: Auth_Field_First_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna`)
};

/**
* | output |
* | --- |
* | "Jane" |
*
* @param {Auth_Field_First_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_field_first_name_placeholder = /** @type {((inputs?: Auth_Field_First_Name_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Field_First_Name_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_field_first_name_placeholder(inputs)
	return en_auth_field_first_name_placeholder(inputs)
});